module.exports = __webpack_public_path__ + "static/media/icons-yc-zoom-out.ba5a8928.svg";